export default "__VITE_ASSET__OJwdEgSw__"